<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="title-box">
                <div class="tit">调查问卷</div>
                <div class="desc">真诚地希望您花几分钟时间完成这个简短的调查，以便我们继续改进，更有效地服务于您。</div>
            </div>
            <div class="paper">
                <div class="item" v-for="(item,index) in paper">
                    <div class="question"><i v-if="item.type > 0">*</i>{{item.question}}</div>
                    <div class="clear option" v-if="item.type == 1">
                        <div class="li" v-for="v in item.option">
                            <div class="tit"><label><input type="radio" @change="validate('select',item.name)" :value="v" v-model="form[item.name]" :name="item.name" ><i></i><span>{{v}}</span></label></div>
                        </div>
                    </div>
                    <div class="clear option" v-if="item.type == 2">
                        <div class="li" v-for="(v,i) in item.option">
                            <div class="tit"><label><input type="checkbox" @change="validate('select',item.name)" :value="v" v-model="form[item.name][i]" :name="item.name"><i></i><span>{{v}}</span></label></div>
                        </div>
                    </div>
                    <div class="clear option" v-if="item.type == 3">
                        <textarea :name="item.name" v-model="form[item.name]" @change="validate('input',item.name)"></textarea>
                    </div>
                    <div class="validate">{{error[item.name]}}</div>
                </div>
                <div class="submit" @click="submit">提交</div>
            </div>
			<sponsor/>
        </div>
    </main>
</template>

<script>
    import Crumbs from "../../../components/pc/Crumbs";
	import Sponsor from "@/components/pc/Sponsor.vue";
    export default {
        name: 'paper',
        data() {
            return {
                key:"",
                adv:{},
                paper:[
                    {type:1,name:"n1",question:"1.您对本次峰会的演讲主题整体是否满意？",option:["非常满意","比较满意","满意","不太满意"]},
                    {type:1,name:"n2",question:"2.你认为本次峰会戴尔有没有创新？",option:["非常创新","创新","有所创新","没有创新"]},
                    {type:1,name:"n3",question:"3.您会将本次峰会推荐给您的商业伙伴或同事吗？",option:["会推荐","不会推荐"]},
                    {type:1,name:"n4",question:"4.如果您方便到现场参加活动而且您的工作场所也允许，您是更愿意到现场参加活动还是继续在线参加？ ",option:["仅到现场参加活动","仅在线参加活动","根据活动内容或地点结合这两种形式"," 无偏好"]},
                    {type:-1,name:"n0",question:"5.对于下列每种活动类型，请指定您更愿意以哪种方式参加。"},
                    {type:1,name:"n5",question:"A.论坛/峰会：在此类会议中，会有一位或多位发言人向观众就一个或多个话题发表演讲。持续时间：1-4 小时",option:["仅到现场参加","仅在线参加","两种方式结合"]},
                    {type:1,name:"n6",question:"B.行业大会/展览会：大规模且持续多天的活动，包括特定行业中的多家供应商",option:["仅到现场参加","仅在线参加","两种方式结合"]},
                    {type:1,name:"n7",question:"C.供应商大会：由一家供应商组织的大规模、持续多天的活动。在此类会议中，业内专业人士可以见面、向专家学习、与同行交流并讨论未来商机",option:["仅到现场参加","仅在线参加","两种方式结合"]},
                    {type:1,name:"n8",question:"D.产品发布：通常由一家企业举办的活动，旨在向潜在客户和媒体介绍新产品或服务。",option:["仅到现场参加","仅在线参加","两种方式结合"]},
                    {type:2,name:"n9",question:"6.以下选项中哪些是影响您决定到现场参加活动的因素？",option:["活动内容","活动地点","会议的总时长（例如半天、多天等）","接触专家","能够与同行联谊"]},
                    {type:2,name:"n10",question:"7.以下选项中哪些是影响您决定在线参加活动的因素？",option:["活动内容","活动地点","会议的总时长（例如半天、多天等）","接触专家","能够与同行联谊"]},
                    {type:3,name:"n11",question:"8.参加本次活动后，您对戴尔的看法是？"},
                    {type:3,name:"n12",question:"9.您对本次峰会还有哪些建议？"},
                ],
                error:[],
                form:{
                    n9:[],
                    n10:[],
                }
            }
        },
        components:{
            Crumbs,Sponsor,
        },
        computed:{
            crumbs() {
				return {title:"调查问卷",min_title:"survey "}
            },
        },
        methods: {
            getAnswer(data,array,name=''){
                var res = [];
                for(var i =0;i<array.length;i++){
                    if(array[i]){
                        var d = data[i].tit;
                        res.push(d);
                    }
                }
                return res;
            },
            inArray(data,array){
                var has = false;
                for(var i =0;i<array.length;i++){
                    if(array[i] == data){
                        has = true;
                    }
                }
                return has;
            },
            validate(field,name = ""){
                var message = "";
                switch (field) {
                    case 'select':
                        if(!this.form[name] || this.form[name].length <= 0){
                            message = "请选择";
                        }else{
                            message = "";
                        }
                        break;
                    case 'input':
						if(!this.form[name] || this.form[name].length <= 0){
							message = "请输入";
						}else{
							message = "";
						}
                        break;
                    default:
                        break;
                }
                this.setError(name ? name : field,message);
                return message ? false : true;
            },
            setError(name,message =""){
                this.error[name] = message;
                this.$forceUpdate();
            },
            setValue(key,value){
                this.form[key] = value;
                this.validate('select',key);
                this.$forceUpdate();
            },
            validateAll(is_watch = false){
                var n1 = this.validate("select","n1");
                var n2 = this.validate("select","n2");
                var n3 = this.validate("select","n3");
                var n4 = this.validate("select","n4");
                var n5 = this.validate("select","n5");
                var n6 = this.validate("select","n6");
                var n7 = this.validate("select","n7");
                var n8 = this.validate("select","n8");
                var n9 = this.validate("select","n9");
                var n10 = this.validate("select","n10");
                var n11 = this.validate("input","n11");
                var n12 = this.validate("input","n12");

                if(!n1 || !n2 || !n3 || !n4 || !n5 || !n6 || !n7  || !n8  || !n9  || !n10  || !n11  || !n12){
                    if(!is_watch){
                        this.$nextTick(()=>{
                            this.scrollError();
                        })
                    }
                    return false;
                }else{
                    return true;
                }
            },
            scrollError(){
                var list = $('.validate');
                for(var i =0;i<list.length;i++){
                    if($(list[i]).text().length > 0){
                        $('body,html').scrollTop($(list[i]).parent().offset().top-100)
                        break;
                    }
                }
            },
			getMultipleData(name){
				var value = this.form[name];
				var option = [];
				var answer = [];
				this.paper.map((item,index)=>{
					if(item.name == name){
						option = item.option;
					}
				})
				value.map((item,index)=>{
					if(item){
						answer.push(option[index])
					}
				})
				return answer;
			},
            submit(){
                var res = this.validateAll();
                if(!res){return false;}
                var data = [];
                data.push({question:"1.您对本次峰会的演讲主题整体是否满意？", answer:this.form['n1']});
                data.push({question:"2.你认为本次峰会戴尔有没有创新？", answer:this.form['n2']});
                data.push({question:"3.您会将本次峰会推荐给您的商业伙伴或同事吗？",  answer:this.form['n3']});
                data.push({question:"4.如果您方便到现场参加活动而且您的工作场所也允许，您是更愿意到现场参加活动还是继续在线参加？",answer:this.form['n4']});
                data.push({question:"A.论坛/峰会：在此类会议中，会有一位或多位发言人向一群人就一个或多个话题发表演讲。持续时间：1-4 小时", answer:this.form['n5']});
                data.push({question:"B.行业大会/展览会：大规模且持续多天的活动，包括特定行业中的多家供应商（例如 Gartner IT 研讨会、XPO、CES）", answer:this.form['n6']});
                data.push({question:"C.供应商大会：由一家供应商组织的大规模、持续多天的活动。在此类会议中，业内专业人士可以见面、向专家学习、与同行交流并讨论未来商机（例如 Cisco Live、VMworld、Oracle OpenWorld）", answer:this.form['n7']});
                data.push({question:"D.产品发布：通常由一家企业举办的活动，旨在向潜在客户和媒体介绍新产品或服务。", answer:this.form['n8']});
                data.push({question:"6.以下选项中哪些是影响您决定到现场参加活动的因素？", answer:this.getMultipleData('n9')});
                data.push({question:"7.以下选项中哪些是影响您决定在线参加活动的因素？", answer:this.getMultipleData('n10')});
                data.push({question:"8.参加本次活动后，您对戴尔的看法是？", answer:this.form['n11']});
                data.push({question:"9.您对本次峰会还有哪些建议？", answer:this.form['n12']});

                var user_info = this.$store.state.user_info;
                if(!user_info.id){
                    this.$toast.fail('请先登录');return  false;
                }

                gio('track', 'DTF2021_surveySubmit', {
                    //'userName':user_info.username,
                    'phoneNumber':this.util.encryptPhone(user_info.mobile),
                    //'company' : user_info.company,
                    //'email' : user_info.email,
                });

                this.http.request({
                    api:"paper/submit",
                    loading:true,
                    data:{
                        uid:user_info.id,
                        //username:user_info.username,
                        mobile:this.util.encryptPhone(user_info.mobile),
                        //email:user_info.email,
                        paper:data
                    },
                    success:(res)=>{
                        this.form = {n9:[], n10:[],};
                        this.$toast.success('提交成功');
                    }
                })
            },
            checkLogin(){
                if(!this.util.getAccessToken()){
                    this.util.showAuth({
                        show:true,
                        close_btn:true,
                    })
                }
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.checkLogin();
            this.util.showBottom(true);
        },
        destroyed() {
            this.util.showAuth({
                show:false,
            })
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{padding-top: 20px;padding-bottom: 30px;
        .title-box{padding:30px;background: #fff;width: 1140px;margin:0 auto;box-shadow:0 0 10px 2px rgba(0,0,0,.1);
            .tit{font-size: 20px;line-height: 16px;border-left: 4px solid #1D56C0;padding-left: 10px;font-weight: bold;}
            .desc{font-size: 18px;margin-top: 10px;line-height: 23px;color:#565656;padding-left: 14px;white-space: pre-line}
        }
        .paper{padding: 30px;width: 1140px;margin: 30px auto 0;font-size: 16px;line-height: 20px;background: #fff;padding-bottom: 40px;
            .item{
                .question{
                    i{color:red;margin-right: 2px;}
                }
                .option{margin-top: 10px;padding-left: 34px;
                    .li{height:36px;line-height: 36px;
						label{cursor: pointer;display: block;}
                        input[type=text]{width: 25px;height:25px;border: 1px solid #cccccc;text-align: center;line-height: 25px;font-size: 16px;color:#000;border-radius: 5px;background: none;}
                        input[type=checkbox],input[type=radio]{display: none;}
                        input[type=checkbox]+i{display: block;float: left;width: 25px;height:36px;background: url("~@/assets/image/a4.png") no-repeat left center;background-size: 20px;transition: all .3s ease;}
                        input[type=checkbox]:checked+i{background: url("~@/assets/image/2024/check1.png") no-repeat left center;background-size: 20px;transition: all .3s ease;}
                        input[type=radio]+i{display: block;float: left; width: 25px;height:36px;background: url("~@/assets/image/a2.png") no-repeat left center;background-size: 20px;transition: all .3s ease;}
                        input[type=radio]:checked+i{background: url("~@/assets/image/2024/r02.png") no-repeat left center;background-size: 20px;transition: all .3s ease;}
                    }
                    textarea{width: 900px;height:46px;padding: 10px;border:1px solid #1D56C0;margin-top: 10px; font-size: 16px;line-height: 22px;}
                }
                .validate{height:25px;line-height: 25px;font-size: 14px;color: red;padding-left: 34px;}
            }
            .submit{width: 160px;height:45px;text-align: center;line-height: 45px;margin: 30px auto 0;font-size: 18px;color:#fff;background: #1D56C0;cursor: pointer;transition: all .3s ease;box-sizing: border-box;}
            .submit:hover{color:#3176c8;background: #fff;transition: all .3s ease;border: 1px solid #3176c8;}
        }
    }
</style>

